/* CYL 2+2 cart-drawer hint (September 2026 campaign).
   The drawer's _render() rebuilds .cd-body innerHTML from JS templates on
   every cart:updated, wiping Liquid-rendered rows, so this hint is injected
   client-side (same pattern as the retired cyl-labor-hint.js and
   cyl-shiloh-hint.js). The Liquid row in sections/cart-drawer.liquid covers
   first paint only; this file owns the row from the first cart:updated onward.

   Two differences from the 3+1 version it replaces:
     1. Two free units, not one. The cart is flattened into UNITS (a line of
        quantity 3 contributes three units) and the two lowest unit prices are
        the free ones, matching how Shopify allocates a Buy 2 Get 2.
     2. Only four products qualify, where 3+1 covered seventeen. So a cart can
        hold four items and still not qualify, and the shopper has no way to
        know why. When non-qualifying lines are present the row says so.

   States (qualifying units counted across the product ids below):
     1 to 3: counter pill "N of 4" + nudge copy + Shop the 2+2 link
     4+:     2+2 chip + "applied" line naming both free items, plus footer rows
             Subtotal (pre-discount) / 2+2 -amount / Total, with the checkout
             button showing the discounted total.
   Also sets body.cyl-2p2-complete and body[data-cyl-2p2-complete] at 4+ so the
   Klaviyo popup can be suppressed with CSS.
   Product ids mirror automatic BXGY discount DiscountAutomaticNode/1786233356655.
   Teardown with the campaign: remove this file and its script tag in
   sections/cart-drawer.liquid (teardown.sh flips the Liquid flag that
   emits the tag). */
(function () {
  var IDS = [14717716300143, 14727252476271, 14882821800303]; /* Oct 16 2026: necklace 2+2, BXGY node 1792287146351 */
  var HINT_ID = 'cyl-2p2-hint';
  var BODY_CLASS = 'cyl-2p2-complete';
  var SHOP = ' <a href="/collections/soil-keepsakes" style="color:#B8956A;text-decoration:underline;white-space:nowrap;">Shop the 2+2</a>';
  var CHIP = 'flex:none;background:#B8956A;color:#FFFFFF;font-family:Montserrat,Arial,sans-serif;font-weight:700;font-size:12px;letter-spacing:0.5px;padding:6px 8px;';

  function money(cents) {
    try {
      if (window.tmsFormatMoney) return window.tmsFormatMoney(cents);
      if (window.Shopify && window.Shopify.formatMoney && window.cartDrawerSettings && window.cartDrawerSettings.moneyFormat) {
        return window.Shopify.formatMoney(cents, window.cartDrawerSettings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (Math.abs(cents) / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* Short labels, so the applied line reads "two Pendants" and not
     "two Pendant of Eternal Faiths". Keyed by product id, same four as IDS. */
  var NAMES = {
    14717716300143: ['Pendant', 'Pendants'],
    14727252476271: ['Locket', 'Lockets'],
    14882821800303: ['Heart', 'Hearts']
  };
  function shortTitle(it) {
    var n = NAMES[it.product_id];
    if (n) return n[0];
    return String(it.product_title || it.title || '').replace(/^The\s+/, '');
  }
  function pluralTitle(it) {
    var n = NAMES[it.product_id];
    if (n) return n[1];
    return shortTitle(it) + 's';
  }

  /* Flatten qualifying lines into units, sort by unit price, take the two
     lowest. Also counts non-qualifying units, and any discount Shopify has
     already applied to qualifying lines (once the automatic discount is ACTIVE
     cart.js reflects it in final_line_price). */
  function analyse(cart) {
    var units = [], qty = 0, other = 0, applied = 0;
    (cart.items || []).forEach(function (it) {
      if (IDS.indexOf(it.product_id) === -1) { other += it.quantity; return; }
      qty += it.quantity;
      var unit = (typeof it.final_price === 'number' ? it.final_price : it.price);
      for (var i = 0; i < it.quantity; i++) units.push({ title: shortTitle(it), plural: pluralTitle(it), price: unit });
      var orig = it.original_line_price != null ? it.original_line_price : it.line_price;
      var fin = it.final_line_price != null ? it.final_line_price : it.line_price;
      if (orig > fin) applied += (orig - fin);
    });
    units.sort(function (a, b) { return a.price - b.price; });
    return { qty: qty, other: other, applied: applied, free: units.slice(0, 2) };
  }

  function freeValue(a) {
    if (a.applied > 0) return a.applied;
    return a.free.reduce(function (s, u) { return s + u.price; }, 0);
  }

  /* "your Pendant ($69) and your Locket ($79)" or, when both free units are the
     same product, "two Pendants ($138)". */
  function freePhrase(a) {
    if (a.free.length < 2) return 'your two lowest priced pieces';
    var x = a.free[0], y = a.free[1];
    if (x.title === y.title) return 'two ' + esc(x.plural) + ' (' + esc(money(freeValue(a))) + ')';
    return 'your ' + esc(x.title) + ' and your ' + esc(y.title) + ' (' + esc(money(freeValue(a))) + ')';
  }

  function copyFor(a) {
    /* Only four products qualify, so a cart can look full and still not count.
       Say which items are not counting rather than leaving a silent counter. */
    var caveat = a.other > 0 && a.qty < 4
      ? ' <span style="opacity:.75;">Only the Pendant, Locket and Heart count toward the 2+2.</span>'
      : '';
    if (a.qty === 1) return '<strong>2+2:</strong> add 3 more and two come free.' + SHOP + caveat;
    if (a.qty === 2) return '<strong>2+2:</strong> add 2 more and two come free.' + SHOP + caveat;
    if (a.qty === 3) return '<strong>One away.</strong> Add 1 more and two come free.' + SHOP + caveat;
    return '<strong>2+2 applied:</strong> ' + freePhrase(a) + ' are free at checkout.';
  }

  function setComplete(on) {
    var b = document.body;
    if (!b) return;
    if (on) { b.classList.add(BODY_CLASS); b.setAttribute('data-cyl-2p2-complete', '1'); }
    else { b.classList.remove(BODY_CLASS); b.removeAttribute('data-cyl-2p2-complete'); }
  }

  /* Footer: Subtotal (pre-discount) / 2+2 -amount / Total, and the checkout
     button shows the discounted total. cart-drawer.js writes its own subtotal
     on every cart:updated before this runs, so these are re-applied each time.
     Once the discount is ACTIVE cart.total_price is already net and the amount
     is Shopify's applied discount; before that it is computed from the two
     lowest units so the preview theme shows the real experience. */
  function renderTotals(cart, a) {
    var disc = document.querySelector('[data-cyl-2p2-discount]');
    var tot = document.querySelector('[data-cyl-2p2-total]');
    if (!disc || !tot) return;
    if (!cart || a.qty < 4 || a.free.length < 2) { disc.hidden = true; tot.hidden = true; return; }
    var original = (cart.items || []).reduce(function (s, it) {
      return s + (it.original_line_price != null ? it.original_line_price : it.line_price);
    }, 0);
    var amount, total;
    if (a.applied > 0) { amount = original - cart.total_price; total = cart.total_price; }
    else { amount = freeValue(a); total = cart.total_price - amount; }
    var sub = document.querySelector('#cart-drawer [data-cd-subtotal]');
    var strike = document.querySelector('#cart-drawer [data-cd-original]');
    var cta = document.querySelector('#cart-drawer [data-cd-cta-subtotal]');
    if (sub) sub.textContent = money(original);
    if (strike) strike.hidden = true;
    var amt = disc.querySelector('[data-cyl-2p2-discount-amount]');
    if (amt) amt.textContent = '-' + money(amount);
    var tamt = tot.querySelector('[data-cyl-2p2-total-amount]');
    if (tamt) tamt.textContent = money(total);
    if (cta) cta.textContent = money(total);
    disc.hidden = false; tot.hidden = false;
  }

  function render(cart) {
    var existing = document.getElementById(HINT_ID);
    if (existing) existing.remove();
    if (!cart || !cart.items || !cart.items.length) { setComplete(false); renderTotals(null, { qty: 0, free: [] }); return; }
    var a = analyse(cart);
    setComplete(a.qty >= 4);
    renderTotals(cart, a);
    /* Sep 15 2026 (Avi): one offer row at a time. The hint shows only once the cart
       already holds two or more Crosses; a single Cross beside other pieces gets the
       free-shipping row alone. */
    if (a.qty < 2) return;
    var host = document.querySelector('#cart-drawer .cd-items');
    if (!host) return;
    var badge = a.qty >= 4 ? '2+2' : (a.qty + ' of 4');
    var div = document.createElement('div');
    div.id = HINT_ID;
    div.className = 'cd-item';
    div.style.cssText = 'background:#F5F1E8;border:1px solid #B8956A;padding:10px 14px;display:flex;align-items:center;gap:10px;';
    div.innerHTML =
      '<div style="' + CHIP + (a.qty >= 4 ? '' : 'white-space:nowrap;') + '">' + badge + '</div>' +
      '<div style="font-family:Heebo,Arial,sans-serif;font-size:13px;color:#3E2723;min-width:0;">' + copyFor(a) + '</div>';
    host.insertBefore(div, host.firstChild);
  }

  document.addEventListener('cart:updated', function (e) {
    render(e.detail && e.detail.cart);
  });

  /* The Liquid in sections/cart-drawer.liquid already renders this row server
     side at first paint, so the boot fetch is only a safety net for a page that
     somehow lacks it. Four separate /cart.js requests were competing during load
     on 2026-09-09 (700ms to 1700ms each, one of them this file's); this one now
     waits for the page to finish and for the browser to be idle, and skips
     entirely when the server already did the work. */
  function boot() {
    if (document.getElementById(HINT_ID)) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }
  function schedule() {
    if (window.requestIdleCallback) window.requestIdleCallback(boot, { timeout: 3000 });
    else setTimeout(boot, 1200);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();



